import { authFetch } from "./authFetch";
import { detectVideoHeader, validatePartenaireVideo } from "@shared/partenaireVideos";
import { uploadVideoWithTus } from "./partenaire-video-tus";

export type VideoUpload = { path: string; size: number; mimetype: string; receipt: string };

export async function uploadPartenaireVideo(file: File, onProgress: (percent: number) => void): Promise<VideoUpload> {
  const { mimeType } = validatePartenaireVideo(file.name, file.type, file.size);
  if (!detectVideoHeader(new Uint8Array(await file.slice(0, 32).arrayBuffer()))) {
    throw new Error("Le contenu du fichier n'est pas une vidéo MP4, MOV ou WebM.");
  }
  const response = await authFetch("/api/partenaires/videos/upload-url", {
    method: "POST", body: JSON.stringify({ nomOrigine: file.name, mimeType, taille: file.size }),
  });
  const signed = await response.json();
  if (!response.ok) throw new Error(signed.message || "Signature d'upload impossible");
  try {
    await uploadVideoWithTus(file, signed, onProgress);
  } catch (error) {
    console.error("[partenaire-videos] envoi échoué, chemin à examiner", signed.path, error);
    throw error;
  }
  return { path: signed.path, size: file.size, mimetype: signed.mimeType, receipt: signed.receipt };
}

export async function confirmPartenaireVideo(upload: VideoUpload, metadata: Record<string, unknown>) {
  try {
    const response = await authFetch("/api/partenaires/videos/confirmation", {
      method: "POST", body: JSON.stringify({ ...metadata, receipt: upload.receipt }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "Confirmation vidéo impossible");
    return data;
  } catch (error) {
    console.error("[partenaire-videos] confirmation échouée, objet potentiellement orphelin", upload.path, error);
    throw error;
  }
}
